import React, { useState } from 'react';
import { SearchBar } from '../ui';
import glossary from '../lib/glossary.json';
import './glossary.css';

export function GlossaryScreen() {
  const [query, setQuery] = useState('');
  const terms = query.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
  const entries = glossary.filter(entry => terms.every(term =>
    `${entry.term} ${entry.definition}`.toLocaleLowerCase().includes(term)
  ));

  return (
    <div className="dp-glossary">
      <header className="dp-glossary-header">
        <div className="dp-glossary-container">
          <h1 className="t-largetitle dp-glossary-title">Glossary</h1>
          <p className="t-subhead dp-glossary-subtitle">Clinical abbreviations used in the library.</p>
          <SearchBar
            id="glossary-search"
            ariaLabel="Find an abbreviation or meaning"
            value={query}
            onChange={setQuery}
            placeholder="Search abbreviations or meanings…"
          />
          <p role="status" className="t-footnote dp-glossary-count">
            {entries.length} {entries.length === 1 ? 'definition' : 'definitions'}
          </p>
        </div>
      </header>
      <div className="dp-glossary-container dp-glossary-results">
        {entries.length === 0 ? <p>No matching definitions. Try another abbreviation or word.</p> : (
          <dl style={{ margin: 0 }}>
            {entries.map(entry => (
              <div key={entry.term} style={{ padding: '14px 0', borderBottom: '1px solid var(--line-divider)' }}>
                <dt className="t-headline" style={{ marginBottom: 4 }}>{entry.term}</dt>
                <dd className="t-body" style={{ margin: 0, color: 'var(--fg-secondary)', overflowWrap: 'anywhere' }}>{entry.definition}</dd>
              </div>
            ))}
          </dl>
        )}
      </div>
    </div>
  );
}
